import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Reject icon — the `ApproveIcon` ring with a cross where that icon has
 * its tick, so the two read as one pair in a status column.
 *
 * Composed from the existing `ApproveIcon` ring and `CloseIcon` cross rather
 * than exported from Figma: the design has this glyph, the icon set does not.
 * The cross is scaled about the centre so its extent matches the tick's rather
 * than touching the ring. Replace this file with the Figma export when it lands.
 */
const RejectIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <rect width="20" height="20" rx="4" fill="#D8D8D8" />
    <g>
      <path
        d="M16.166 10.001C16.166 6.61056 13.3904 3.83416 10 3.83398C6.60948 3.83398 3.83301 6.61045 3.83301 10.001C3.83319 13.3914 6.60958 16.167 10 16.167C13.3903 16.1668 16.1658 13.3912 16.166 10.001ZM17.166 10.001C17.1658 13.9435 13.9426 17.1668 10 17.167C6.0573 17.167 2.83319 13.9436 2.83301 10.001C2.83301 6.05817 6.05719 2.83398 10 2.83398C13.9427 2.83416 17.166 6.05828 17.166 10.001Z"
        fill="#A4A4A4"
      />
      <g transform="translate(10 10) scale(0.74) translate(-10 -10)">
        <path
          d="M13.6464 5.64645C13.8417 5.45118 14.1582 5.45119 14.3535 5.64645C14.5487 5.84171 14.5487 6.15822 14.3535 6.35348L10.707 9.99996L14.3535 13.6464C14.5487 13.8417 14.5487 14.1582 14.3535 14.3535C14.1582 14.5487 13.8417 14.5487 13.6464 14.3535L9.99996 10.707L6.35348 14.3535C6.15822 14.5487 5.84171 14.5487 5.64645 14.3535C5.45119 14.1582 5.45118 13.8417 5.64645 13.6464L9.29293 9.99996L5.64645 6.35348C5.45119 6.15821 5.45119 5.84171 5.64645 5.64645C5.84171 5.45119 6.15822 5.45119 6.35348 5.64645L9.99996 9.29293L13.6464 5.64645Z"
          fill="#A4A4A4"
        />
      </g>
    </g>
  </svg>
);

export default RejectIcon;
